import { useMemo } from 'react';

import { useCurrentProject } from '../ProjectEntitlementsContext';
import type { EntitlementsProject } from '../projectEntitlementTypes';

/**
 * A hook to get the tools for a product in the current project. Should be used for custom side navigation implementations.
 * @param productId - the id of the product to get the tools for in the current project
 * @returns the tools for the product
 */
export function useProjectProductTools({
  productId,
}: {
  productId?: string;
}): EntitlementsProject['products'][number]['tools'] {
  const currentProject = useCurrentProject();

  return useMemo(() => {
    if (!productId) {
      return [];
    }

    const currentProduct = currentProject?.products.find(
      (product) => product.key === productId,
    );

    return (
      currentProduct?.tools.filter((tool) => tool.authorized !== false) || []
    );
  }, [currentProject?.products, productId]);
}
